webpackJsonp([4],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(38);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _manual = __webpack_require__(217);
	
	var _manual2 = _interopRequireDefault(_manual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	new _vue2.default({
	  el: '#app',
	  template: '<manual/>',
	  components: { manual: _manual2.default }
	});

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var apiLinks = void 0;
	
	var enterpriseId = 284;
	var yc = 'https://yc.yonyoucloud.com';
	
	exports.apiLinks = apiLinks = {
	  materiaClass: yc + '/yuncai/jsonp/pubmaterialClass?enterpriseId=' + enterpriseId,
	  orgClass: yc + '/yuncai/org/getorgbydef?pageIndex=0&pageSize=100&org_type=2&org_types=0&enterprise_id=' + enterpriseId,
	
	  southCement: {
	    home: 'http://www.shanghaiwater.com/'
	  },
	  caslogout: '/yuncai/caslogout',
	
	  register: yc + '/yuncai/privateportal#/pages/supplymgr/supplyapplyregister?purentid=' + enterpriseId + '&agree=1&ipuid=chengtou',
	
	  enterWorkbench: yc + '/workbench/sso/login.jsp',
	
	  suppliersFor: yc + '/yuncai/SSO/registerredirect4yuncaismi.html?v=' + Date.parse(new Date().toLocaleDateString()),
	
	  infoTable: {
	    latest: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', 'latest2', 'latest3'],
	    area: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', 'area2', 'area3', 'area4', 'area5', 'area6', 'area7', 'area8'],
	    type: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', '2', '3', '4']
	  },
	
	  purchasetableDate: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=0&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=4&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=5&pageSize=10&pageIndex=0', '', ''],
	
	  logisticstableDate: ['', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=6&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=7&pageSize=10&pageIndex=0', '', ''],
	
	  logisticsestableDate: ['', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=11&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=13&pageSize=10&pageIndex=0'],
	
	  engineeringtableDate: ['', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=12&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=14&pageSize=10&pageIndex=0'],
	
	  details: {
	    bidDoc: yc + '/cpu-fe-bid/dist/bidddocread/index.html?type=1&id=',
	    bidDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowother/index.html?show=1&id=',
	    bidNotice: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
	    bidMsg: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
	    inquiryDetails: yc + '/cpu-fe-tender/dist/inquirydetail/index.html?id='
	  },
	
	  notice: {
	    company: '',
	    bidding: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allBidNotice&supEnterpriseIds=' + enterpriseId + '&status=5&pageIndex=0&pageSize=6',
	    clarify: ''
	  },
	
	  contact: yc + '/cpu-project-def/ycctrl/projectdef/getBidCountInfo?enterpriseId=' + enterpriseId,
	
	  agreement: yc + '/cpu-supplymgr/supplyApply/isExistApply?purEntId=' + enterpriseId
	};
	exports.apiLinks = apiLinks;

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _links = __webpack_require__(1);
	
	exports.default = {
	  name: 'gheader',
	  props: {
	    type: ''
	  },
	  data: function data() {
	    return {
	      southCement: _links.apiLinks.southCement['home'],
	      enterWorkbench: _links.apiLinks.enterWorkbench,
	      caslogout: _links.apiLinks.caslogout
	    };
	  }
	};

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'grednav',
	  props: {
	    type: ''
	  }
	};

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(18)
	
	/* script */
	__vue_exports__ = __webpack_require__(10)
	
	/* template */
	var __vue_template__ = __webpack_require__(24)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(17)
	
	/* template */
	var __vue_template__ = __webpack_require__(23)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(16)
	
	/* script */
	__vue_exports__ = __webpack_require__(11)
	
	/* template */
	var __vue_template__ = __webpack_require__(22)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-red-nav"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('ul', {
	    staticClass: "list-basic-settings",
	    attrs: {
	      "id": "red-nav-navbar"
	    }
	  }, [_c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "home.html"
	    }
	  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "purchase.html"
	    }
	  }, [_vm._v("物资招标")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "logisticses.html"
	    }
	  }, [_vm._v("工程招标")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "engineering.html"
	    }
	  }, [_vm._v("服务招标")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "contact.html"
	    }
	  }, [_vm._v("联系我们")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "https://www.yonyouyc.com/yuncai"
	    }
	  }, [_vm._v("返回官网")])])])])])
	}]}

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-logo"
	  }, [_c('div', {
	    staticClass: "main-width set-position"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/logo2.jpg",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "inline-block",
	      "position": "relative",
	      "top": "25px",
	      "left": "10px"
	    }
	  }, [_vm._v("帮助企业做"), _c('br'), _vm._v("最佳采购决策和高效协同")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group pull-right hidden"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "搜索商机/物资"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/search.png"
	    }
	  })])])])])])
	}]}

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-nav"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('div', {
	    attrs: {
	      "id": "row-nav-navbar"
	    }
	  }, [_c('ul', {
	    staticClass: "list-basic-settings pull-right"
	  }, [(_vm.type == 'home') ? [_vm._m(0)] : [_vm._m(1)], _vm._v(" "), _c('li', {
	    staticClass: "cashome-li-a"
	  }, [_vm._v("|  "), _c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.caslogout
	    }
	  }, [_vm._v("退出")])])], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": "home.html"
	    }
	  }, [_vm._v("首页")]), _vm._v("   ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": "cashome.html"
	    }
	  }, [_vm._v("首页")]), _vm._v("   ")])
	}]}

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GHeader = __webpack_require__(19);
	
	var _GHeader2 = _interopRequireDefault(_GHeader);
	
	var _GLogo = __webpack_require__(20);
	
	var _GLogo2 = _interopRequireDefault(_GLogo);
	
	var _GRednav = __webpack_require__(21);
	
	var _GRednav2 = _interopRequireDefault(_GRednav);
	
	var _links = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    gheader: _GHeader2.default,
	    glogo: _GLogo2.default,
	    grednav: _GRednav2.default
	  },
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    enterlink: function enterlink() {
	      var str = window.location.href;
	      var array = str.split('?');
	      if (array[1] === 'register') {
	        window.location.href = _links.apiLinks.register;
	      } else if (array[1] === 'applyFor') {
	        window.location.href = _links.apiLinks.suppliersFor;
	      }
	    }
	  }
	};

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(202)
	
	/* script */
	__vue_exports__ = __webpack_require__(146)
	
	/* template */
	var __vue_template__ = __webpack_require__(220)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 220:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('gheader', {
	    attrs: {
	      "type": "home"
	    }
	  }), _vm._v(" "), _c('glogo'), _vm._v(" "), _vm._m(0)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-agreement"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('div', {
	    attrs: {
	      "id": "agreement"
	    }
	  }, [_c('h2', {
	    attrs: {
	      "id": "title"
	    }
	  }, [_vm._v("供应商操作手册")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "source"
	    }
	  }, [_c('p')]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "content"
	    }
	  }, [_c('h3', [_vm._v("一、供应商须知")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("尊敬的供应商：")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("您好！")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("目前友云采已经上线了网上招标采购系统，未来我们会招标的很多流程都会放在网上，期待您注册网上招采平台跟友云采长期合作。")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("为了帮助您更好的了解和掌握此系统，我们编写的以下操作手册，希望能够帮到您。以后如果在使用过程中遇到问题，一定要记得及时联系我们哦。")]), _vm._v(" "), _c('h3', [_vm._v("二、供应商注册申请流程-企业用户注册")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_0.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h4', [_vm._v("1.网上招采地址")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("请在浏览器中输入地址https://yc.yonyoucloud.com/smisupply/home.html登陆城投水务供应商资料信息完善门户。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h4', [_vm._v("2.供应商注册")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("希望参加友云采采购招标的供应商需要在网上申请成为友云采的供应商。")]), _vm._v(" "), _c('h5', [_vm._v("2.1 开始注册")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("点击“供应商注册”按钮开始注册。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_1.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h5', [_vm._v("2.2 确认相关条款")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("同意并继续后开始填写相关资料")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_2.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h5', [_vm._v("2.3 填写账号信息")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("手机号：需要用手机号进行注册（一个手机号只能注册一个账号）")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("账号：即登录友云采进行报名，投标等操作的账号（账号必须是唯一的无法重复）")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("密码：账户的密码")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("企业名称：请确认是公司全称，注册后无法修改。")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("相关信息填写完整后点击“下一步，完善供应商信息”系统会提示“您的账号已经注册成功”")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual4.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h5', [_vm._v("2.4 回到首页")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("点击“供应商资料信息完善” -进入登录页面 - 点击“忘记密码”")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual5.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual6.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h5', [_vm._v("2.5 找回密码")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("重新设定密码")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual7.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h5', [_vm._v("2.6 供应商资料信息完善")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("点击“登录”")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual8.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual9.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h4', [_vm._v("3.完善资质信息")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("3.1 完善供应商资质信息")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应商名称：由上一步代入")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("管理组织：即确定您提交的资料由哪一家公司审核，选择分公司对应的本部，比如“供水公司本部” 。")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应商资质信息：请选择是上传三证还是五证，并需要填写相关证件号。供应商还可以新增资质证件。")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应品类：即您要申请的供货类别，请选择到最末级（请如实填写），"), _c('span', {
	    staticClass: "redFont"
	  }, [_vm._v("所有上传的附件以及证件都需要提交资料须企业法人代表签字并加盖单位公章；国外供应商应提供相应的资料，外文版资料应提供相应中文翻译件")])]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("继续完善资料")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("相关资料填写完成后点击“提交采购商审核即可”")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual10.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual11.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual12.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual13.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("(1).如果资质证件到期日为无限定日期，则在发证日期+50年，比如发证日期2003年10月9日，则到期日为2053年10月9日。")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("(2).供应商资质信息点击“添加资质”即跳出资质选择弹窗，可以通过快速搜索进行查找，然后勾选，另外也可以通过点击左侧分类查找，选中对应的资质等级")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual14.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("(1).供应品类则选择对应提供的服务，选择最末级的类别，建议主要选择与城投发生业务往来的服务项")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("(2).资质信息全部完善之后，点击“提交审核”即可")]), _vm._v(" "), _c('h4', [_vm._v("4.供应商申请结果查询")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("4.1 查看供应商审核是否通过")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("(1).账号登录")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应商登录账号，登录后点击进入工作台。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual15.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("(2).查看供应商申请界面，点击左侧“客户管理”，点击“我的申请”即可")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual16.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("(3).查看审核是否通过")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("待审核状态可以查看相关供应商资料，申请被驳回后，可以修改相关资料重新提交，申请通过后可以进入云采平台供应商档案。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual17.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h3', [_vm._v("三、管理组织准入审批操作流程")]), _vm._v(" "), _c('h4', [_vm._v("1.采购方管理组织审核")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应商注册提交后，采购方管理组织权限的人员进入工作台后，点击“准入管理”查看待审核供应商详情。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual18.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h4', [_vm._v("2. 采购方管理组织审核")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("点击“查看详情”，可查看到供应商详情档案，如材料没问题，会判断供应商材料是否为相似供应商，可以点击“合并”，然后点击“准入”")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual19.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual20.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("如果材料有问题，则点击驳回并提交理由，供应商进入工作台在供应商申请单中驳回中，然后重新填写继续提交申请。")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("注：可以通过供应商准入状态上的数量计算完善供应商信息的数量，只需计算待审核+已通过的供应商。，右上角的搜素框支持搜索查询供应商。")]), _vm._v(" "), _c('h4', [_vm._v("3. 供应商档案")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("点击“查看详情”，可查看到供应商详情档案。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual21.png",
	      "alt": ""
	    }
	  })])])])])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/api/manual.73341066a8840ade7f01.js